import { FC, HTMLAttributes, MouseEvent } from "react";
import { ElAccordion, ElAccordionAction, ElAccordionPannel, ElAccordionPannelContent, ElAccordionWrapper } from "./accordion.css";
import { Icons } from "../../icons";

interface IAccordionProps extends HTMLAttributes<HTMLElement> {
  data: {
    title: string;
    desc: string;
  }[];
}

export const Accordion: FC<IAccordionProps> = ({ children, data, ...props }) => {
  const onOpen = (key: string) => (e: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
    const pannel = document.getElementById(key);
    if (pannel) {
      if (pannel?.className.match("active")) {
        pannel.classList.remove("active");
        e.currentTarget.classList.remove("active");
      } else {
        pannel.classList.add("active");
        e.currentTarget.classList.add("active");
      }
    }
  };

  return (
    <ElAccordion {...props}>
      {data.map((accordion, key) => (
        <ElAccordionWrapper key={key}>
          <ElAccordionAction onClick={onOpen(`key_${key}`)}>
            <span>{accordion.title}</span>
            <Icons icon={"chevron-down"} />
          </ElAccordionAction>
          <ElAccordionPannel id={`key_${key}`}>
            <ElAccordionPannelContent dangerouslySetInnerHTML={{ __html: accordion.desc }} />
          </ElAccordionPannel>
        </ElAccordionWrapper>
      ))}
    </ElAccordion>
  );
};
